import { render, staticRenderFns } from "./ManufacturerPage.vue?vue&type=template&id=350abba8&scoped=true"
import script from "./ManufacturerPage.vue?vue&type=script&lang=js"
export * from "./ManufacturerPage.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerPage.vue?vue&type=style&index=0&id=350abba8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350abba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350abba8')) {
      api.createRecord('350abba8', component.options)
    } else {
      api.reload('350abba8', component.options)
    }
    module.hot.accept("./ManufacturerPage.vue?vue&type=template&id=350abba8&scoped=true", function () {
      api.rerender('350abba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/volumeAudit/ManufacturerPage.vue"
export default component.exports